// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { ModalConfirm } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { lightGrey } from '@fortress-technology-solutions/fortress-component-library/design';
import { DASHES } from '@fortress-technology-solutions/fortress-component-library/constants';
import confirmMessages from '../../../../components/ConfirmDialogModal/messages';
import tabMessages from '../messages';
import type { CancelGrossRentCertificationModalCert } from '../types';

type CancelGrossRentCertificationModalProps = {
  cert: ?CancelGrossRentCertificationModalCert,
  isSubmitting?: boolean,
  onCancel: () => void,
  onConfirm: () => void,
  open: boolean,
};

const CancelGrossRentCertificationModal = ({
  cert,
  isSubmitting = false,
  onCancel,
  onConfirm,
  open,
}: CancelGrossRentCertificationModalProps) => {
  return (
    <ModalConfirm
      open={open}
      onClose={onCancel}
      title={<FormattedMessage {...tabMessages.cancelCertificationModalTitle} />}
      TitleProps={{
        sx: (theme) => ({
          ...theme.typography.titleLarge,
        }),
      }}
      actionsProps={[
        {
          children: <FormattedMessage {...confirmMessages.cancel} />,
          onClick: onCancel,
          variant: 'text',
        },
        {
          children: <FormattedMessage {...confirmMessages.confirm} />,
          onClick: onConfirm,
          submitButton: true,
          isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      ContentProps={{
        sx: {
          maxWidth: 565,
        },
      }}
    >
      <Typography variant="bodyMedium" color={lightGrey.dark} display="block">
        <FormattedMessage
          {...tabMessages.cancelCertificationModalBody}
          values={{
            // A row can carry an empty unit or head of household when the underlying customer
            // record is incomplete. Falling back to an empty string would read as
            // "Unit  - ?", so use the same placeholder the rest of the screen uses.
            unit: cert?.unit || DASHES,
            headOfHousehold: cert?.headOfHousehold || DASHES,
          }}
        />
      </Typography>
    </ModalConfirm>
  );
};

export default CancelGrossRentCertificationModal;
